
export const LgSizes18Icon = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2.75584" y="3.75584" width="26.4445" height="13.34" stroke="#909090" strokeWidth="1.51169"/>
            <rect x="8.48582" y="17.1262" width="15.1578" height="10.8168" stroke="#909090" strokeWidth="1.51169"/>
        </svg>
    )
}

export const LgSizes18Icon = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2.75584" y="3.75584" width="26.4445" height="13.34" stroke="#909090" strokeWidth="1.51169"/>
            <rect x="8.48582" y="17.1262" width="15.1578" height="10.8168" stroke="#909090" strokeWidth="1.51169"/>
        </svg>
    )
}
